var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPetHabitats = function SvgPetHabitats(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LABELS"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 195.82,
    width: 157.37,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 195.82,
    width: 107.06,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 221.98,
    width: 157.37,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 145.15,
    width: 157.37,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 221.98,
    width: 107.06,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 169.67,
    width: 157.37,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 169.67,
    width: 107.06,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.23 334.77 262.04 348.29 383.68 348.29 383.68 334.77 243.23 334.77",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.68 359.29 277.33 359.29 298.41 374.44 383.68 374.44 383.68 359.29",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 334.77,
    width: 107.06,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 246.5,
    width: 107.06,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.57 374.44 258.49 359.29 226.31 359.29 226.31 374.44 279.57 374.44",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.31 348.29 243.19 348.29 226.31 336.15 226.31 348.29",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 246.5,
    width: 101.79,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.34 436.11 226.31 436.11 226.31 446.48 379.76 446.48 365.34 436.11",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 436.11,
    width: 107.06,
    height: 10.37,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.47,436.11H394.68v8.42a6.37,6.37,0,0,1-.31,2h102.1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 145.15,
    width: 107.06,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 359.29,
    width: 107.06,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,86a11.51,11.51,0,0,0-11.5-11.5H238.81A11.51,11.51,0,0,0,227.31,86v23.17H383.68v-.08h-1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,323.77a9,9,0,0,1-2.74-.67v.67Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 297.39,
    width: 107.06,
    height: 0.26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,272.86v-.21H108.25v.92a8.9,8.9,0,0,1,3.5-.71Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.71 385.44 334.79 400.59 383.68 400.59 383.68 385.44 313.71 385.44",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.08 411.59 368.89 425.11 383.68 425.11 383.68 411.59 350.08 411.59",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.31 411.59 226.31 425.11 350.04 425.11 331.24 411.59 226.31 411.59",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 120.15,
    width: 157.37,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,134.15v-14H127.75a19.52,19.52,0,0,0-18.69,14Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 145.15,
    width: 101.79,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.67,134.15a19.53,19.53,0,0,0-18.7-14H394.68v14Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 411.59,
    width: 107.06,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 195.82,
    width: 101.79,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 272.65,
    width: 101.79,
    height: 0.21,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 297.39,
    width: 101.79,
    height: 0.26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 411.59,
    width: 101.79,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 385.44,
    width: 107.06,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 169.67,
    width: 101.79,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 359.29,
    width: 101.79,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 272.65,
    width: 157.37,
    height: 0.21,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 334.77,
    width: 101.79,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 297.39,
    width: 157.37,
    height: 0.26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 385.44,
    width: 101.79,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 246.5,
    width: 157.37,
    height: 15.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.68,
    y: 221.98,
    width: 101.79,
    height: 13.52,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.87 385.44 226.31 385.44 226.31 400.59 315.94 400.59 294.87 385.44",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.47,139.65a30.53,30.53,0,0,0-30.5-30.5H394.68v-.08h-11v.08H227.31v1h-13v-1H127.75a30.54,30.54,0,0,0-30.5,30.5V446.48h11V436.11H215.31v10.37h11V436.11h139l14.42,10.37,4.63,3.33a6.49,6.49,0,0,0,10-3.33,6.37,6.37,0,0,0,.31-2v-8.42H496.47v10.37h11Zm-11,122H394.68V246.5H496.47ZM368.89,425.11l-18.81-13.52h33.6v13.52Zm-34.11-24.52-21.07-15.15h70v15.15Zm-232-85.78V297.65h5.5v-.26h-5.5V281.86a9,9,0,0,1,5.5-8.29v-.92H215.31v51.12H108.25v-.67A9,9,0,0,1,102.75,314.81ZM215.31,145.15v13.52H108.25V145.15Zm11,65.83V195.82H383.68V211Zm157.37,11V235.5H226.31V222ZM226.31,184.82V169.67H383.68v15.15Zm0-26.15V145.15H383.68v13.52Zm-11,11v15.15H108.25V169.67Zm0,26.15V211H108.25V195.82Zm0,26.16V235.5H108.25V222Zm0,24.52v15.15H108.25V246.5Zm43.18,112.79,21.08,15.15H226.31V359.29Zm-32.18-11V336.15l16.88,12.14Zm51,11H383.68v15.15H298.41Zm-15.3-11-18.81-13.52H383.68v13.52Zm-46.73-13.52v13.52H108.25V334.77Zm0,24.52v15.15H108.25V359.29Zm0,26.15v15.15H108.25V385.44Zm11,0h68.56l21.07,15.15H226.31Zm168.37,0H496.47v15.15H394.68Zm0-11V359.29H496.47v15.15Zm0-26.15V334.77H496.47v13.52ZM227.94,323.77l-.65-.46-.33.46h-.65V272.65H383.68v51.12Zm-1.63-62.12V246.5H383.68v15.15ZM496.47,235.5H394.68V222H496.47Zm0-24.52H394.68V195.82H496.47Zm0-26.16H394.68V169.67H496.47Zm0-26.15H394.68V145.15H496.47ZM477,120.15a19.53,19.53,0,0,1,18.7,14h-101v-14Zm-93.29,0v14H226.31v-14Zm-255.93,0h87.56v14H109.06A19.52,19.52,0,0,1,127.75,120.15Zm-19.5,305V411.59H215.31v13.52Zm118.06,0V411.59H331.24L350,425.11Zm168.37,0V411.59H496.47v13.52ZM506.26,297.39h-9.79v.26h9.79v17.16a9,9,0,0,1-8.24,9H394.68V272.65H496.47v.21h.79a9,9,0,0,1,9,9Z",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.37,489a9,9,0,0,0,9,9H144v-.37H471.46V498h8.43a9,9,0,0,0,9-9V472.63H124.37Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.47,446.48H394.37a6.45,6.45,0,0,1-3.22,3.83,6.49,6.49,0,0,1-6.76-.5l-4.63-3.33h-277v17.15a9,9,0,0,0,9,9H497.26a9,9,0,0,0,9-9V446.48h-9.79Z",
    fill: "#ef6ba0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,323.77V297.65H102.75v17.16a9,9,0,0,0,8.24,9Z",
    fill: "#ef6ba0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.31 297.65 226.31 323.77 226.96 323.77 227.29 323.31 227.94 323.77 383.68 323.77 383.68 297.65 226.31 297.65",
    fill: "#ef6ba0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.68,323.77H498a9,9,0,0,0,8.24-9V297.65H394.68Z",
    fill: "#ef6ba0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,272.86H111.75a8.9,8.9,0,0,0-3.5.71,9,9,0,0,0-5.5,8.29v15.53H215.31Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.31,
    y: 272.86,
    width: 157.37,
    height: 24.53,
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.26,272.86H394.68v24.53H506.26V281.86A9,9,0,0,0,497.26,272.86Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,497.6v17.16a9,9,0,0,0,9,9H462.46a9,9,0,0,0,9-9V497.6Z",
    fill: "#ef6ba0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.33,
    y: 523.94,
    width: 75.19,
    height: 17.98,
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.19,
    y: 523.94,
    width: 75.19,
    height: 17.98,
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.31,110.17V86a11.51,11.51,0,0,1,11.5-11.5H371.18A11.51,11.51,0,0,1,382.68,86v23.09h13V86a24.53,24.53,0,0,0-24.5-24.5H238.81A24.53,24.53,0,0,0,214.31,86v24.19Z",
    fill: "#ef6ba0"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPetHabitats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pet_habitats.8d139cec.svg";
export { ForwardRef as ReactComponent };